import { message } from 'antd';
import { accAdd, accSub } from '../../util/math';
import { ADD_PRODUCT, REDUCE_PRODUCT, REMOVE_PRODUCT, CLEAR_PRODUCT, MODIFY_PRODUCT, RESTORE_SHOPCART, } from '../constants';
import { requestCartInfo, requestAddProduct, requestModifyProduct, requestRemoveProduct, } from '../request';

export function addProduct(product, count = 1, showMessage = true) {
  return function (dispatch, getState) {
    const state = getState();
    const {
      shopCart: { products },
    } = state;
    const productInfo = products[product.normsId];
    let num = count;
    if (productInfo) {
      num = accAdd(productInfo.num, count);
    }
    requestAddProduct(product.id, num, product.unit).then(res => {
      if (res.data.code === 0) {
        showMessage && message.success('成功加入购物车', 1);
        dispatch({
          type: ADD_PRODUCT,
          product,
          count
        });
      }
    }
    );
  };
}
export function reduceProduct(normsId) {
  return function (dispatch, getState) {
    const state = getState();
    const {
      shopCart: { products },
    } = state;
    const product = products[normsId];
    const product_mixins_number = accSub(product.num, 1);
    if (product && product_mixins_number >= 0) {
      requestModifyProduct(product.cartId, product_mixins_number);
    }
    dispatch({
      type: REDUCE_PRODUCT,
      product,
    });
  };
}
export function removeProduct(normsId, cartId) {
  return function (dispatch) {
    requestRemoveProduct(Array.isArray(cartId) ? cartId : [cartId]);
    dispatch({
      type: REMOVE_PRODUCT,
      normsId,
    });
  };
}
export function clearProduct() {
  return function (dispatch, getState) {
    const state = getState();
    const {
      shopCart: { cartIds },
    } = state;
    requestRemoveProduct(cartIds);
    dispatch({
      type: CLEAR_PRODUCT,
    });
  };
}
export function modifyProduct(product, num) {
  return function (dispatch) {
    requestModifyProduct(product.cartId, num);
    dispatch({
      type: MODIFY_PRODUCT,
      product,
      num,
    });
  };
}
export function initShopCart() {
  return function (dispatch) {
    requestCartInfo((products) => {
      dispatch({
        type: RESTORE_SHOPCART,
        products: products.map(item => ({ ...item, number: +item.number, num: +item.num })),
      });
    });
  };
}
